import styles from './PageNotFound.less';

import React, { Component } from 'react';

export default class PageNotFound extends Component {

  render() {
    return (
      <div className={styles.root} data-automation="pageNotFound">
        <p className={styles.heading}>
          Sorry, there doesn&rsquo;t seem to be anything here&hellip;
        </p>
        <ul className={styles.ul}>
          <li className={styles.li}>
            Check the URL, there may be a typo.
          </li>
          <li className={styles.li}>
            If all else fails, try going back.
          </li>
        </ul>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/PageNotFound/PageNotFound.js
 **/